import { appThemeClasses } from '../../plugins/general';

/**
 * Returns the app theme, either its slug or complete css class name
 * @param state {object} The redux state
 * @param format {string} 'cssClass' or 'slug'
 * @returns {string} The CSS class or slug for the app theme
 */
export const getAppTheme = (state, format) => {
  const themeSlug = state.app.theme;
  let valueToReturn;

  if (format === 'cssClass') {
    valueToReturn = appThemeClasses[themeSlug];
  } else if (format === 'slug') {
    valueToReturn = themeSlug;
  }

  return valueToReturn;
};
